import { type FC } from 'react';

import {
  ActivateMultiDecisionButton,
  MerchantsLimiter,
  MerchantsListSort,
} from '@features/merchant';

import { Flex } from '@shared/ui-kit';

interface Props {
  loading: boolean;
  total: number;
  count: number;
}

const MerchantsListHeader: FC<Props> = ({ loading, total, count }) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
    >
      <MerchantsLimiter
        loading={loading}
        total={total}
        count={count}
      />
      <Flex
        alignItems="center"
        columnGap="2.5"
      >
        <MerchantsListSort loading={loading} />
        <ActivateMultiDecisionButton loading={loading} />
      </Flex>
    </Flex>
  );
};

export default MerchantsListHeader;
